import { render, staticRenderFns } from "./PeopleList.vue?vue&type=template&id=30b659c2"
import script from "./PeopleList.vue?vue&type=script&lang=js"
export * from "./PeopleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports